import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'


class IndexBloc {

    listPeriodChannel = new Subject()
    inactiveChannel = new Subject()
    hirarkiChannel = new Subject();
    hirarkiJabatanChannel = new Subject();

    repository = new IndexRepository()

    constructor() {
        this.listPeriodChannel.next({status: apiResponse.INITIAL})
        this.inactiveChannel.next({status: apiResponse.INITIAL})
        this.hirarkiChannel.next({status: apiResponse.INITIAL})
        this.hirarkiJabatanChannel.next({status: apiResponse.INITIAL})
    }

    fetchListPeriod = async (query) => {
        try {
            this.listPeriodChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListPeriod(query).then((result) => {
                this.listPeriodChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listPeriodChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchInactive = async (query) => {
        try {
            this.inactiveChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchInactive(query).then((result) => {
                this.inactiveChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.inactiveChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchHirarki = async (query) => {
        try {
            this.hirarkiChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchHirarki(query).then((result) => {
                this.hirarkiChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.hirarkiChannel.next({status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    fetchHirarkiJabatan = async (query) => {
        try {
            this.hirarkiJabatanChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchHirarkiJabatan(query).then((result) => {
                this.hirarkiJabatanChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.hirarkiJabatanChannel.next({status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }
}

export default IndexBloc